import React from 'react';

// Generic table. Props:
//  columns: [{ key, label, align, render(row, idx) }]
//  rows, loading, emptyMessage, onRowClick, getRowKey, rowClassName
export default function DataTable({
  columns,
  rows,
  loading,
  emptyMessage = 'No data found.',
  onRowClick,
  getRowKey,
  rowClassName,
}) {
  if (loading) return <div className="loading">Loading data…</div>;
  if (!rows || rows.length === 0) return <div className="empty-state">{emptyMessage}</div>;

  return (
    <div className="table-responsive">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr
              key={getRowKey ? getRowKey(row, idx) : idx}
              className={[onRowClick ? 'clickable' : '', rowClassName ? rowClassName(row, idx) : '']
                .filter(Boolean)
                .join(' ')}
              onClick={onRowClick ? () => onRowClick(row, idx) : undefined}
            >
              {columns.map((col) => (
                <td key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                  {col.render ? col.render(row, idx) : row[col.key] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
